import React, { Component } from 'react';
import axios from 'axios';
import moment from "moment";
import { APIURL } from '../../../config'
import {Card, CardActions, CardContent, IconButton, Dialog, DialogActions, DialogContent, Typography, TextField, InputAdornment, Button } from '@mui/material'
import { NavLink } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close';
import ProjectForm from '../../../components/forms/ProjectForm/ProjectForm';
import SearchIcon from '@mui/icons-material/Search';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

class Projects extends Component {
    state = {
        selectedTab: 0,
        searchTerm: '',
        tabs: ['Ongoing', 'Completed'],
        onGoingProjs: [],
        completedProjs: [],
        loading: true,
        displayProjects: [],
        content: [],
        contextMenu: 0,
        newProjLoading: true,
        employees: {
            list: [{}],
            empType: [],
            empLevel: [],
            empStatus: [],
            currency: [],
            frequency: [],
        },
        customers: { list: [{}], customerType: [], customerStatus: [] },
        locations: { list: [{}], states: [], locType: [], locStatus: [] },
        mapRender: "proj",
    }

    async fetchData() {
        console.log('Projects fetchData called with cus_id:', this.props.cus_id);
        const response = await axios.get(APIURL + `/project`, { params: { cus_id: this.props.cus_id } })
        let projectsData = response.data
        console.log('Raw projects data from API:', projectsData);

        let projects = await Promise.all(projectsData.map(async (project) => {
            let completedTaskData = await axios.get(APIURL + '/locate/TimeSpent', { params: { projId: project.pro_id, comp_id: this.props.comp_id } })

            return { ...project, taskData: completedTaskData.data }
        }))
        console.log('Projects with task data:', projects)

        // Update state first, then use the projects data directly for generating cards
        // this.setState({ displayProjects: projects }, () => {
        //     // This callback runs after state is updated
        //     this.generateProjCards(projects); // Use the projects data directly, not state
        // });

        this.generateProjCards(projects);
        this.setState({ loading: false })
    }

    async fetchNewProjData() {
        let data = {
            employees: {
                list: (
                    await axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", {
                        params: { comp_id: this.props.comp_id },
                    })
                ).data,
                empType: [],
                empLevel: [],
                empStatus: (
                    await axios.get(APIURL + "/dropdowns/dropdownType/empStatus", {
                        params: { comp_id: this.props.comp_id },
                    })
                ).data,
                currency: [],
                frequency: (
                    await axios.get(APIURL + "/config/defaults", {
                        params: { feature_type: "payrollFrequency" },
                    })
                ).data,
            },
            customers: {
                list: (
                    await axios.get(APIURL + "/dropdowns/dropdownType/customerslist", {
                        params: { comp_id: this.props.comp_id },
                    })
                ).data,
                customerType: [],
                customerStatus: [],
            },
            locations: {
                list: (
                    await axios.get(APIURL + "/dropdowns/dropdownType/locationslist", {
                        params: { comp_id: this.props.comp_id },
                    })
                ).data,
                states: [],
                locType: [],
                locStatus: [],
            },
            payers: {
                list: (
                    await axios.get(APIURL + "/associate_payer", {
                        params: { compId: this.props.comp_id },
                    })
                ).data.filter((p) => p.id),
            },
        };

        this.setState({ ...data });
        this.setState({ newProjLoading: false });
    }

    componentDidMount = () => {
        this.fetchData()
        this.fetchNewProjData()
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.cus_id !== this.props.cus_id) {
            this.fetchData()
        }

        // if (this.state.contextMenu === 1 && !!this.state.newProjLoading) {
        //     await this.fetchNewProjData()
        // }
    }

    generateProjCard = (project, i) => {
        let phoneNumbers = []
        let addresses = []
        try {
            phoneNumbers = this.props.cust_details.cus_phone.split(',')
            addresses = this.props.cust_details.cus_address.split(':')
        } catch (err) {
            console.log(err)
        }
        let timeSpent = this.calCumulativeTimeSpent(project.taskData)
        let taskCount = project.taskData.length

        return (
            <Card
                key={i}
                sx={{
                    marginTop: '20px',
                    borderRadius: '10px',
                    border: '1.5px solid #E9E9E9',
                    background: '#fff',
                    boxShadow: '0 2px 6px rgba(34,34,34,0.04)',
                    fontFamily: 'Lato, Arial, sans-serif',
                }}
            >
                <CardActions
                    sx={{
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        paddingTop: '18px',
                        paddingBottom: '0px',
                        fontFamily: 'Lato, Arial, sans-serif',
                        background: '#F7FAFC',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                    }}
                >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{
                            textDecoration: 'underline',
                            marginBottom: '5px',
                            fontWeight: 600,
                            fontSize: '1.15rem',
                            color: '#222',
                            fontFamily: 'Lato, Arial, sans-serif'
                        }}>
                            <NavLink
                                to={{
                                    pathname: '/projects',
                                    projectsProps: { pro_id: project.pro_id, cus_id: this.props.cus_id },
                                }}
                                className='navlink_name_color'
                                style={{
                                    color: '#1976d2',
                                    fontFamily: 'Lato, Arial, sans-serif',
                                    fontWeight: 600,
                                    fontSize: '1.15rem',
                                    textDecoration: 'underline'
                                }}
                            >
                                {project.pro_title}
                            </NavLink>
                        </div>
                        {project.pro_starts_on && project.pro_ends_on && moment(project.pro_starts_on).isAfter("1900-01-01") && moment(project.pro_ends_on).isAfter("1900-01-01") ?
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.95rem', color: '#888', fontFamily: 'Lato, Arial, sans-serif' }}>
                                <CalendarTodayIcon sx={{ fontSize: 18, marginRight: '6px', color: '#888' }} />
                                {moment(project.pro_starts_on).format('MMMM DD, YYYY')} - {moment(project.pro_ends_on).format('MMMM DD, YYYY')}
                            </div>
                            :
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.95rem', color: '#888', fontFamily: 'Lato, Arial, sans-serif' }}>
                                <CalendarTodayIcon sx={{ fontSize: 18, marginRight: '6px', color: '#888' }} />
                                Initial Plan
                            </div>
                        }
                    </div>
                </CardActions>
                <CardContent
                    sx={{
                        paddingBottom: '12px',
                        paddingTop: '12px',
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        fontFamily: 'Lato, Arial, sans-serif'
                    }}
                >
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 24,
                        fontFamily: 'Lato, Arial, sans-serif'
                    }}>
                        <div style={{ minWidth: 140 }}>
                            <div style={{ color: '#222', fontWeight: 700, fontSize: '1rem', marginBottom: 4, fontFamily: 'Lato, Arial, sans-serif' }}>
                                TIME SPENT ON TASKS
                            </div>
                            <div style={{ color: '#1976d2', fontWeight: 500, fontSize: '1.1rem', fontFamily: 'Lato, Arial, sans-serif' }}>
                                {timeSpent}
                            </div>
                            <div style={{ color: '#666', fontSize: '0.95rem', fontFamily: 'Lato, Arial, sans-serif' }}>
                                spent on {taskCount} tasks
                            </div>
                        </div>
                        <div style={{ minWidth: 140 }}>
                            <div style={{ color: '#222', fontWeight: 700, fontSize: '1rem', marginBottom: 4, fontFamily: 'Lato, Arial, sans-serif' }}>
                                PHONE NUMBER
                            </div>
                            <div className="d-flex flex-column" style={{ fontFamily: 'Lato, Arial, sans-serif' }}>
                                {phoneNumbers.map((number, i) =>
                                    <Typography key={i} style={{ fontFamily: 'Lato, Arial, sans-serif', fontSize: '0.98rem', color: '#444' }}>
                                        <span>{number}</span>
                                    </Typography>
                                )}
                            </div>
                        </div>
                        <div style={{ minWidth: 140 }}>
                            <div style={{ color: '#222', fontWeight: 700, fontSize: '1rem', marginBottom: 4, fontFamily: 'Lato, Arial, sans-serif' }}>
                                LOCATION
                            </div>
                            <div className="d-flex flex-column" style={{ fontFamily: 'Lato, Arial, sans-serif' }}>
                                {addresses.map((address, i) =>
                                    <Typography key={i} style={{ fontFamily: 'Lato, Arial, sans-serif', fontSize: '0.98rem', color: '#444' }}>
                                        <span>{address}</span>
                                    </Typography>
                                )}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        )
    }

    generateProjCards = (projList) => {        
        let onGoing = projList.filter((project) => {
            const endDate = moment(project.pro_ends_on);
            const startDate = moment(project.pro_starts_on);
            const today = moment();
            
            // A project is ongoing if:
            // 1. End date is today or in the future, OR
            // 2. Project has no valid dates (null/undefined start or end dates), OR
            // 3. Start date is invalid (before 1900)
            const hasValidEndDate = project.pro_ends_on && endDate.isValid();
            const hasValidStartDate = project.pro_starts_on && startDate.isValid();
            const endDateIsAfterToday = hasValidEndDate && endDate.isSameOrAfter(today, 'day');
            const hasInvalidDates = !hasValidStartDate || !hasValidEndDate || startDate.isSameOrBefore("1900-01-01");
            
            const isOngoing = endDateIsAfterToday || hasInvalidDates;
            
            return isOngoing;
        });
        
        let completed = projList.filter((project) => {
            const endDate = moment(project.pro_ends_on);
            const startDate = moment(project.pro_starts_on);
            const today = moment();
            
            // A project is completed if:
            // 1. Has valid start and end dates, AND
            // 2. Start date is after 1900, AND
            // 3. End date is before today
            const hasValidEndDate = project.pro_ends_on && endDate.isValid();
            const hasValidStartDate = project.pro_starts_on && startDate.isValid();
            const endDateIsBeforeToday = hasValidEndDate && endDate.isBefore(today, 'day');
            const startDateIsAfter1900 = hasValidStartDate && startDate.isAfter("1900-01-01");
            
            return hasValidStartDate && hasValidEndDate && startDateIsAfter1900 && endDateIsBeforeToday;
        });

        // let onGoingCards = onGoing.map((project, i) => {
        //     return this.generateProjCard(project, i)
        // })
        // let completedCards = completed.map((project, i) => {
        //     return this.generateProjCard(project, i)
        // })
        this.setState({ onGoingProjs: onGoing, completedProjs: completed })
    }

    calCumulativeTimeSpent = (data) => {
        var TotalTime = moment()
        data.forEach((taskData) => {
            var CheckInTime = moment(taskData.CheckInTime)
            var CheckoutTime = moment(taskData.CheckoutTime)
            var taskTime = moment.duration(CheckoutTime.diff(CheckInTime))
            TotalTime.add(taskTime)
        })
        return moment.duration(TotalTime.diff(moment())).humanize()
    }

    selectTaskTab(tabIndex) {
        this.setState({
            selectedTab: tabIndex
        })
    }

    navigationHandler = (contextMenu) => {
        this.setState({ contextMenu })
    }

    searchProjHandler = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        this.setState({ searchTerm }, this.filterProjects);
    }

    filterProjects = () => {
        const { selectedTab, searchTerm, onGoingProjs, completedProjs } = this.state;
        const projList = selectedTab === 0 ? onGoingProjs : completedProjs;

        const filteredProjects = projList.filter(pro =>
            pro.pro_title.toLowerCase().includes(searchTerm)
        );
        this.setState({ displayProjects: filteredProjects });
    }

    render() {
        let content = null;
        const projectsForCards = this.state.searchTerm.trim() 
            ? this.state.displayProjects
            : this.state.selectedTab === 0 
                ? this.state.onGoingProjs
                : this.state.completedProjs

        if (this.state.contextMenu === 1) {
            content =
                <Dialog 
                    fullWidth={true} 
                    maxWidth={'sm'} 
                    open={this.state.contextMenu === 1} 
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                            this.navigationHandler(0);
                        }
                    }}
                >
                    {this.props.user.permissions.createNewProject && <DialogActions>
                        <h4 style={{ marginLeft: '20px', marginTop: '10px' }}>New Project</h4>
                        <hr style={{ marginBottom: '10px', marginTop: '10px', backgroundColor: '#e2ecfa' }}></hr>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.25 }}
                            onClick={() => this.navigationHandler(0)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>}
                    <DialogContent sx={{ paddingTop: '0px' }}>
                        {!!this.state.newProjLoading &&
                            <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        }
                        {!this.state.newProjLoading && <ProjectForm
                            {...this.props}
                            isFormValidated={this.props.isNewFormValidated}
                            mapRender={this.state.mapRender}
                            customerList={this.state.customers.list}
                            empList={this.state.employees.list}
                            payerList={this.state.payers.list}
                            // contactList={this.state.contacts.list}
                            locList={this.state.locations.list}
                            empStatus={this.state.employees.empStatus}
                            currency={this.state.employees.currency}
                            frequency={this.state.employees.frequency}
                            comp_id={this.props.comp_id}
                            customerPage={true}
                            customer_id={this.props.cus_id}
                        />}

                    </DialogContent>
                </Dialog>
        }
        else if (this.state.contextMenu === 0) {
            content = (
                <div className="TasksPage" style={{ height: '100%' }}>
                    <div className="TopPanel">
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                onChange={this.searchProjHandler}
                                value={this.state.searchTerm}
                                placeholder="Search"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton type="submit">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                            <Button onClick={() => this.navigationHandler(1)} variant="contained" color="primary" sx={{ height: '40px' }}>New Project</Button>
                        </div>
                    </div>
                    <div className='tasks_info' style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: 'auto' }}>
                        <div>
                            <h5>Projects</h5>
                        </div>
                        <div className='task_button_group'>
                            <div style={{ opacity: '90%' }} className={`project_button ${this.state.tabs[this.state.selectedTab] === 'Ongoing' ? 'active' : 'inactive'}`} onClick={() => this.selectTaskTab(0)}>
                                <div>On Going</div>
                                {this.state.tabs[this.state.selectedTab] === 'Ongoing' && <div className='project_button_number'>{this.state.onGoingProjs.length}</div>}
                            </div>
                            <div style={{ opacity: '90%' }} className={`project_button ${this.state.tabs[this.state.selectedTab] === 'Completed' ? 'active' : 'inactive'}`} onClick={() => this.selectTaskTab(1)}>
                                <div>Completed</div>
                                {this.state.tabs[this.state.selectedTab] === 'Completed' && <div className='project_button_number'>{this.state.completedProjs.length}</div>}
                            </div>
                        </div>
                        {!!this.state.loading &&
                            <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        }
                        {/* {!this.state.loading && this.state.selectedTab === 0 && this.state.onGoingProjs.length === 0 &&
                            <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '500px', marginTop: 10 }}>
                                <img src={'./nosearchresult.png'} alt='projectgraphic' style={{ width: '15rem', height: '10rem', margin: 10 }} />
                                <h5 style={{ fontFamily: 'Lato', marginTop: 48, marginBottom: 30 }} className='text-center'>No Projects Found</h5>
                            </div>
                        }
                        {!this.state.loading && this.state.selectedTab === 1 && this.state.completedProjs.length === 0 &&
                            <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '500px', marginTop: 10 }}>
                                <img src={'./nosearchresult.png'} alt='projectgraphic' style={{ width: '15rem', height: '10rem', margin: 10 }} />
                                <h5 style={{ fontFamily: 'Lato', marginTop: 48, marginBottom: 30 }} className='text-center'>No Projects Found</h5>
                            </div>
                        } */}
                        {!this.state.loading && projectsForCards.length === 0 &&
                            <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '500px', marginTop: 10 }}>
                                <img src={'./nosearchresult.png'} alt='projectgraphic' style={{ width: '15rem', height: '10rem', margin: 10 }} />
                                <h5 style={{ fontFamily: 'Lato', marginTop: 48, marginBottom: 30 }} className='text-center'>No Projects Found</h5>
                            </div>
                        }
                        {!this.state.loading && projectsForCards.length > 0 &&
                            <div
                                className="taskCardList"
                                style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', alignContent: 'start', flex: 1, minHeight: 0, overflowY: 'auto' }}
                            >
                                {projectsForCards.map((project, i) => this.generateProjCard(project, i))}
                            </div>
                        }
                    </div>
                </div>
            )
        }
        return (
            <div style={{ height: '100%' }}>
                {content}
            </div>
        )
    }
}

export default Projects;